import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_CONTROL_LOG, APP_FILE_CONTROL_LOG_LIST, APP_FILE_CSIO_LIST, APP_FILE_CSIO_MAPING, APP_FILE_CSIO_PROGRESS, APP_FILE_MANAGE_CSIO_TAB } from "./CSIO.constants";

const CSIOLIst = Loadable(
  lazy(() =>
    import("./ManageCsioTabs/CSIOTabs").then(({ CSIOTabs }) => ({
      default: CSIOTabs,
    }))
  )
);

const CSIOProgress = Loadable(
  lazy(() =>
    import("./CSIOProgress").then(({ CSIOProgress }) => ({
      default: CSIOProgress,
    }))
  )
);
const ManageCSIOTabs = Loadable(
  lazy(() =>
    import("./ManageCSIOTabs").then(({ ManageCSIOTabs }) => ({
      default: ManageCSIOTabs,
    }))
  )
);
const CSIOMaping = Loadable(
  lazy(() =>
    import("./CSIOMapping").then(({ CSIOMaping }) => ({
      default: CSIOMaping,
    }))
  )
);
const ControlLogList = Loadable(
  lazy(() =>
    import("./ContolLog/ControlLogList").then(
      ({ ControlLogList }) => ({
        default: ControlLogList,
      })
    )
  )
);
const ControlLog = Loadable(
  lazy(() =>
    import("./ContolLog/ControlLogView").then(
      ({ ControlLogView }) => ({
        default: ControlLogView,
      })
    )
  )
);


export const CSIORoutes = [
   {
          path: `${APP_FILE_CSIO_LIST}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO]}>
              <CSIOLIst />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_CSIO_PROGRESS}/:code`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess={true} moduleKeys={[]}>
              <CSIOProgress />
            </AuthorizedRoute>
          ),
        },
        {
                path: `${APP_FILE_MANAGE_CSIO_TAB}/`,
                exact: true,
                element: (
                  <AuthorizedRoute allowFullAccess={true} moduleKeys={[]}>
                    <ManageCSIOTabs />
                  </AuthorizedRoute>
                ),
              },
              {
                path: `${APP_FILE_MANAGE_CSIO_TAB}/:id`,
                exact: true,
                element: (
                  <AuthorizedRoute allowFullAccess={true} moduleKeys={[]}>
                    <ManageCSIOTabs />
                  </AuthorizedRoute>
                ),
              },
                {
                      path: `${APP_FILE_CSIO_MAPING}`,
                      exact: true,
                      element: (
                        <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_MAPPING]}>
                          <CSIOMaping />
                        </AuthorizedRoute>
                      ),
                    },
                    {
                      path: `${APP_FILE_CONTROL_LOG_LIST}`,
                      exact: true,
                      element: (
                        <AuthorizedRoute allowFullAccess moduleKeys={[]}>
                          <ControlLogList />
                        </AuthorizedRoute>
                      ),
                    },
                    {
                      path: `${APP_FILE_CONTROL_LOG}/:messageGuid`,
                      exact: true,
                      element: (
                        <AuthorizedRoute allowFullAccess moduleKeys={[]}>
                          <ControlLog />
                        </AuthorizedRoute>
                      ),
                    },
];
